function isEditableTarget(target) {
  if (!target) return false;
  const tag = String(target.tagName || "").toLowerCase();
  if (tag === "input" || tag === "textarea" || tag === "select") return true;
  return Boolean(target.isContentEditable);
}

function normalizeKey(key) {
  const k = String(key || "").toLowerCase();
  if (k === " ") return "space";
  return k;
}

function parseCombo(combo) {
  const parts = String(combo || "")
    .toLowerCase()
    .split("+")
    .map((x) => x.trim())
    .filter(Boolean);
  const out = { ctrl: false, alt: false, shift: false, key: "" };
  parts.forEach((p) => {
    if (p === "ctrl" || p === "control") out.ctrl = true;
    else if (p === "alt") out.alt = true;
    else if (p === "shift") out.shift = true;
    else out.key = p;
  });
  return out;
}

export function matchHotkey(event, combo) {
  const c = parseCombo(combo);
  if (Boolean(event.ctrlKey) !== c.ctrl) return false;
  if (Boolean(event.altKey) !== c.alt) return false;
  if (Boolean(event.shiftKey) !== c.shift) return false;
  return normalizeKey(event.key) === c.key;
}

export function shouldIgnoreGlobalHotkeys(event) {
  return isEditableTarget(event?.target);
}
